import { DefaultAdvancedCareProviderSearchFilters } from "@/modules/care-provider/advanced-search/advanced-care-provider-search-dialog"
import { CareProviderSearchType } from "@/types/__generated__/union-types"

export const DEFAULT_ADVANCED_FILTERS_BY_SEARCH_TYPE: Partial<
  Record<CareProviderSearchType, DefaultAdvancedCareProviderSearchFilters>
> = {
  MEDICAL_EMERGENCY_OR_PERMANENCE: { groupType: "DOCTOR", isWalkIn: true },
}
